import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Profile } from "../../../../../@types/profile";
import DelendCentralizedCircularProgress from "../../../../../components/CircularProgress/DelendCentralizedCircularProgress";
import { useAppSelector } from "../../../../../hooks/hooks";
import ReturnButton from "../../ReturnButton";
import UserService from "../../../../../services/UserService";

const ResetPasswordHeader = () => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={1} mb={2}>
      <Typography variant="h2">Esqueci minha senha</Typography>
      <Typography>
        Favor confirmar a ação para receber o link de recuperação de senha
      </Typography>
    </Box>
  );
};

const PasswordEditor: React.FC = () => {
  const navigate = useNavigate();
  const profile = useAppSelector<Profile | undefined>(
    (state) => state.profileSlice.profile
  );

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  if (!profile) return <DelendCentralizedCircularProgress />;

  const handleResetPasswordbuttonClick = async () => {
    try {
      setIsButtonDisabled(true);
      await UserService.forgotPassword({ username: profile.person.email });
      setIsButtonDisabled(false);
      toast.success("Link de recuperação enviado com sucesso!");
      navigate("/dashboard/profile");
    } catch (error) {
      setIsButtonDisabled(false);
      toast.error("" + error);
    }
  };

  return (
    <React.Fragment>
      <Box display={"flex"} gap={2}>
        <ReturnButton to="/dashboard/profile" />
        <Box
          display={"flex"}
          width={"100%"}
          flexDirection={"column"}
          gap={2}
          component="form"
          noValidate
          autoComplete="off"
        >
          <ResetPasswordHeader />
          <Box display={"flex"} justifyContent={"center"}>
            <Button
              variant="outlined"
              size="large"
              disabled={isButtonDisabled}
              onClick={handleResetPasswordbuttonClick}
            >
              enviar link de recuperação por e-mail
            </Button>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default PasswordEditor;
